module.exports = __webpack_public_path__ + "assets/images/project/cambodia-desktop.jpg?v=c212ef7f";